// ── ViriLogoFace — base64 PNG face icon ──────────────────────────────────
import { _FACE_B64 } from '../../data/logoData';

function ViriLogoFace({ size = 52 }) {
  // Natural aspect ratio: 486x571 → 0.85:1
  const displayW = size;
  const displayH = Math.round((size * 571) / 486);
  return (
    <img
      src={`data:image/png;base64,${_FACE_B64}`}
      width={displayW}
      height={displayH}
      alt="Viri's Clayworks"
      style={{ display: 'block' }}
    />
  );
}

export default ViriLogoFace;
